import React from 'react';
import {
    Box, Typography, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, CircularProgress,
} from '@mui/material';

const formatPrice = (val) => val != null ? `$${Number(val).toFixed(2)}` : '-';
const formatPercent = (val) => val != null ? `${Number(val).toFixed(2)}%` : '-';
const formatDate = (val) => val ? new Date(val).toLocaleDateString() : '-';
const formatDateTime = (val) => val ? new Date(val).toLocaleString() : '-';
const formatNumber = (val) => val != null ? Number(val).toLocaleString() : '-';

const SectionTitle = ({ children }) => (
    <Typography variant="h6" sx={{ mb: 2, mt: 3, fontWeight: 600, fontSize: '1rem' }}>{children}</Typography>
);
const EmptyState = ({ message }) => (
    <Box sx={{ py: 4, textAlign: 'center' }}><Typography color="text.secondary">{message || 'No data available'}</Typography></Box>
);
const TabLoading = () => (
    <Box sx={{ py: 4, textAlign: 'center' }}><CircularProgress /></Box>
);

const ETFsTab = ({ data, loading, error }) => {
    if (loading) return <TabLoading />;
    if (error) return <EmptyState message={error} />;
    if (!data) return <EmptyState />;

    const { etf_correlations = [] } = data;

    return (
        <Box>
            {/* ETF Correlations */}
            <SectionTitle>ETF Correlations</SectionTitle>
            {etf_correlations.length === 0 ? <EmptyState message="No ETF correlation data available" /> : (
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Asset A</TableCell>
                                <TableCell>Asset B</TableCell>
                                <TableCell align="right">Correlation Coefficient</TableCell>
                                <TableCell align="right">Window Days</TableCell>
                                <TableCell>Calculation Date</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {etf_correlations.map((row, idx) => (
                                <TableRow key={idx}>
                                    <TableCell>{row.asset_a_symbol || '-'}</TableCell>
                                    <TableCell>{row.asset_b_symbol || '-'}</TableCell>
                                    <TableCell align="right">{formatNumber(row.correlation_coefficient)}</TableCell>
                                    <TableCell align="right">{formatNumber(row.window_days)}</TableCell>
                                    <TableCell>{formatDate(row.calculation_date)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Box>
    );
};

export default ETFsTab;
